import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { JobBoardService } from '../service/job-board.service';

@Component({
  selector: 'app-job-board-group-by',
  templateUrl: './job-board-group-by.component.html',
  styleUrls: ['./job-board-group-by.component.scss'],
})
export class JobBoardGroupByComponent implements OnInit {
  constructor(private jobBoardService: JobBoardService) {}

  @Output() group: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('groupBy') groupBy: any;

  async ngOnInit(): Promise<void> {
    let localFilterState = await this.jobBoardService.getLocalBoardFilterState();
    if (this.groupBy?.nativeElement)
      this.groupBy.nativeElement.value = localFilterState?.jobBoardGroupByProperty || 'none';
  }

  groupBoardData(groupByProperty: String) {
    this.group.emit(groupByProperty);
  }
}
